export default __webpack_public_path__ + "static/media/becados_formato.37a565fa.xlsx";